import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {GlobalService} from '../../../service/global.service';
import {ModalService} from '../../../service/modal.service';
import {Params} from '../../enums/parametro.enum';

@Component({
    selector: 'edicao-artefatos-modal',
    templateUrl: './edicao-artefatos-modal.component.html',
    styleUrls: ['./edicao-artefatos-modal.component.css']
})

export class EdicaoArtefatosModalComponent {

    private manterEdicao: boolean = true;
    mensagem: string;

    constructor(private globalService: GlobalService, public modalService: ModalService, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route
            .queryParams
            .subscribe(params => {
                this.mensagem = params['mensagem'];
            });
    }

    manterVersaoVigente(): void {
        this.modalService.incluirDadosGerados({tipoEdicao: true});
        this.confirmar();
    }

    gravarUmaNovaVersao(): void {
        this.modalService.incluirDadosGerados({tipoEdicao: false});
        this.confirmar();
    }

    confirmar(): void {
        this.modalService.fecharPaginaModal();
    }

    getMaterEdicao(): boolean {
        return this.manterEdicao;
    }

    setManterEdicao(status: boolean): void {
        this.manterEdicao = status;
    }
}



// WEBPACK FOOTER //
// ./src/app/modal/edicao-artefatos/edicao-artefatos-modal.component.ts